export default __webpack_public_path__ + "public/images/apart/living-banner@3x.png?c4444ddd";